import { computed } from 'vue';
import { UserRoles, PERMISSIONS, UserRole } from '@/modules/admin/interfaces/UserRoles';
import { useUser } from './useUser';

export const useUserRoles = () => {
  const { user } = useUser();

  const userRole = computed(() => user.value?.role?.name as UserRole | undefined);

  const isAdmin = computed(() => userRole.value === UserRoles.ADMIN);
  const isGatekeeper = computed(() => userRole.value === UserRoles.GATEKEEPER);
  const isSupervisor = computed(() => userRole.value === UserRoles.SUPERVISOR);
  const isJudge = computed(() => userRole.value === UserRoles.JUDGE);
  
  // Permission-based checks
  const canCreateUsers = computed(() => 
    userRole.value && PERMISSIONS.CREATE_USERS.includes(userRole.value)
  );
  
  const canCreateBattles = computed(() => 
    userRole.value && PERMISSIONS.CREATE_BATTLES.includes(userRole.value)
  );
  
  const canEditBattles = computed(() =>
    userRole.value && PERMISSIONS.UPDATE_OWN_BATTLES.includes(userRole.value)
  );

  const canDeleteBattles = computed(() => 
    userRole.value && PERMISSIONS.DELETE_BATTLES.includes(userRole.value)
  );
  
  const canJudgeBattles = computed(() => 
    userRole.value && PERMISSIONS.JUDGE_BATTLES.includes(userRole.value)
  );


  const isSupervisorOrHigher = computed(
    () => isAdmin.value || isGatekeeper.value || isSupervisor.value,
  );

  /** User is viewing as spectator (not in judge role for this context). Red side shown on right when true. */
  const isSpectator = computed(() => !isJudge.value);

  return {
    userRole,
    isAdmin,
    isGatekeeper,
    isSupervisor,
    isJudge,
    isSpectator,
    isSupervisorOrHigher,
    canCreateUsers,
    canCreateBattles,
    canEditBattles,
    canDeleteBattles,
    canJudgeBattles,
  };
};

